import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, apiUrl } from "../../../utils/apis";
import type {
  Notification,
  NotificationPayload,
  NotificationsResponse,
} from "./types";

export const notificationApi = createApi({
  reducerPath: "notificationApi",

  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem("token");
      headers.set("Content-Type", "application/json");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  tagTypes: ["Notification"],

  endpoints: (builder) => ({
    // 🔹 GET NOTIFICATIONS
getNotifications: builder.query<
  NotificationsResponse,
  { page: number; limit: number }
>({
  query: ({ page, limit }) => ({
    url: apiUrl.notificationsApi,
    method: "GET",
    params: { page, limit },
  }),
  providesTags: ["Notification"],
}),


    // 🔹 CREATE NOTIFICATION
    createNotification: builder.mutation<
      {
        message: string; success: boolean; data: Notification 
},
      NotificationPayload
    >({
      query: (body) => ({
        url: apiUrl.notificationsApi,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Notification"],
    }),

    // 🔹 DELETE NOTIFICATION
    deleteNotification: builder.mutation<
      {
        message: string; success: boolean 
},
      number
    >({
      query: (id) => ({
        url: `${apiUrl.notificationsApi}${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Notification"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useCreateNotificationMutation,
  useDeleteNotificationMutation,
} = notificationApi;
